import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'
import { Button } from '@mui/material'
import Stack from 'ui/layout/Stack'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(2, 2, 2, 0),
  },
  right: {
    display: 'inline-flex',
    alignItems: 'center',
  },
}))

export type DepartmentReadControlBarProps = {
  onClickDelete: () => void
  onClickEdit: () => void
  unDeletable?: boolean
}

const DepartmentReadControlBar: React.FC<DepartmentReadControlBarProps> = ({
  onClickDelete,
  onClickEdit,
  unDeletable,
}: DepartmentReadControlBarProps) => {
  const { t } = useTranslation()
  const { classes } = useStyles()

  return (
    <Stack className={classes.root}>
      <div>
        <Button
          color={'secondary'}
          onClick={onClickDelete}
          disabled={unDeletable}
        >
          {t('削除')}
        </Button>
      </div>
      <div className={classes.right}>
        <Button variant={'contained'} color={'primary'} onClick={onClickEdit}>
          {t('編集')}
        </Button>
      </div>
    </Stack>
  )
}

export default DepartmentReadControlBar
